
export default {
  name: 'SalesChannelModalComponent',
  props:{
    //- 是否顯示禮物兌換紀錄
    isSalesChannelModalShow: {
      type: Boolean,
      required: true
    },
    salesChannelInfo: {
      type: String,
      default: null
    }
  },
  methods:{
    //- 關閉
    closeHandler: function () {
      let vm = this;
      vm.resetHandler();
      //- 呼叫父元件
      vm.$emit('closeHandler');
    },
    //- 初始化
    resetHandler: function () {
      let vm = this;
    },
  },
}